import { ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { Divider as DividerLib } from '@ui-kitten/components';

import { colors, spacing } from '../../theme';

export const Divider = ({ style, ...props }: ComponentProps<typeof DividerLib>) => {
	return <DividerLib style={[styles.divider, style]} {...props} />;
};

const styles = StyleSheet.create({
	divider: {
		alignSelf: 'stretch',
		backgroundColor: colors.background300,
		marginVertical: spacing(),
	},
});
